/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'text': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M0 0v256h64c0-70.4 57.6-128 128-128h192v704c0 35.84-28.16 64-64 64h-64v128h512V896h-64c-35.84 0-64-28.16-64-64V128h192c70.4 0 128 57.6 128 128h64V0H0z"/>'
  }
})
